const namespace = 'ConnectionForm';

export const SET_PARAMS = `${namespace}/SET_PARAMS`;




// WEBPACK FOOTER //
// ./src/containers/ReservationConnectionForm/constants.js